<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field placeholder="Số điện thoại" v-model="phone" clearable flat outlined dense hide-details />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field placeholder="Họ tên" v-model="buyerName" clearable flat outlined dense hide-details />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field placeholder="Email" v-model="email" clearable flat outlined dense hide-details />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="2">
        <v-btn color="primary" height="40px" width="100%" outlined @click="onFilterChanged">
          Tìm kiếm
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-select
              item-text="title"
              item-value="value"
              placeholder="Phân khúc"
              v-model="segment"
              :items="segmentOptions"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-select
              item-text="title"
              item-value="value"
              placeholder="Hệ đào tạo quan tâm"
              v-model="product"
              :items="formattedProducts"
              clearable
              outlined
              dense
              hide-details
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title v-html="formatExamOption(data.item)"></v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-slot:selection="data">
                <span v-html="formatExamSelection(data.item)"></span>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-select
              item-text="title"
              item-value="value"
              v-model="interest"
              placeholder="Mức độ quan tâm"
              :items="interestOptions"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-select
              item-text="title"
              item-value="value"
              placeholder="Người chịu trách nhiệm"
              v-model="inCharge"
              :items="formattedUsers"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4"> </v-col>
          <v-col cols="12" xs="12" sm="12" md="4"> </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="d-flex justify-space-between " cols="12" xs="12" sm="12" md="10">
        <v-row>
          <v-col class="pb-0" cols="12" xs="12" sm="12" md="4">
            <v-text-field
              v-if="advancedFilter"
              v-model="studentNameSearchField"
              placeholder="Tên học sinh"
              clearable
              flat
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col class="pb-0" cols="12" xs="12" sm="12" md="4">
            <v-combobox
              v-if="advancedFilter"
              :items="schoolOptions"
              v-model="studentSchoolSearchField"
              item-text="name"
              item-value="name"
              outlined
              clearable
              dense
              hide-details
              :return-object="false"
              autocomplete="on"
              placeholder="Trường đang học"
            ></v-combobox>
          </v-col>
          <v-col class="pb-0" cols="12" xs="12" sm="12" md="4">
            <v-text-field
              v-if="advancedFilter"
              placeholder="Nguồn marketing"
              v-model="importOrigin"
              clearable
              flat
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="2">
        <v-btn color="primary" height="40px" width="100%" @click="advancedFilter = !advancedFilter" text>
          Nâng cao <v-icon v-if="!advancedFilter">mdi-chevron-down</v-icon
          ><v-icon v-if="advancedFilter">mdi-chevron-up</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="advancedFilter">
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-combobox
              :items="schoolOptions"
              v-model="expectSchoolSearchField"
              item-text="name"
              item-value="name"
              outlined
              dense
              hide-details
              clearable
              :return-object="false"
              :rules="[$rules.required]"
              autocomplete="on"
              placeholder="Nguyện vọng 1"
            ></v-combobox>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field
              v-if="advancedFilter"
              v-model="studentClassSearchField"
              placeholder="Lớp"
              clearable
              flat
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-select
              item-text="title"
              item-value="value"
              placeholder="Mã hồ sơ"
              :items="activeCodesOptions"
              v-model="activeCodes"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="advancedFilter">
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-select
              item-text="title"
              item-value="value"
              placeholder="Năm học"
              :items="schoolYears"
              v-model="selectedSchoolYear"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import eleSchool from '@/assets/ele_school.json'
import secondarySchool from '@/assets/secondary_school.json'
import highSchool from '@/assets/high_school.json'
import utils from '@/plugins/utils'
import {mapActions, mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters('auth', ['user']),
    formattedProducts() {
      return this.products.map(p => ({title: p.name, value: p.id, grade: p.grade}))
    },
    formattedUsers() {
      return this.users.map(u => ({title: u.name ? u.name : u.username, value: u.id}))
    }
  },
  props: {
    users: Array,
    products: Array
  },
  data() {
    return {
      advancedFilter: false,
      show: false,
      phone: '',
      buyerName: '',
      email: '',
      studentNameSearchField: '',
      studentClassSearchField: '',
      studentSchoolSearchField: '',
      expectSchoolSearchField: '',
      type: '',
      product: [],
      inCharge: [],
      importOrigin: '',
      activeCodes: '',
      studentExpectation: '',
      selectedSchoolYear: '2023-2024',
      segment: {},
      interest: {},
      segmentOptions: [
        {title: 'Phổ thông', value: 'intermediate'},
        {title: 'Cao cấp', value: 'advance'}
      ],
      interestOptions: [
        {title: 'Thấp', value: 'cold'},
        {title: 'Vừa', value: 'warm'},
        {title: 'Cao', value: 'hot'}
      ],
      activeCodesOptions: [
        {title: 'Có', value: 'true'},
        {title: 'Chưa có', value: 'false'}
      ],
      schoolOptions: [...eleSchool, ...secondarySchool, ...highSchool],
      schoolYears: [{title: 'Năm học 2023-2024', value: '2023-2024'}]
    }
  },
  methods: {
    ...mapActions('user', ['fetchAdminUsers']),
    onFilterChanged() {
      let query = {
        phone_contains: this.phone,
        buyerName_contains: this.buyerName,
        email_contains: this.email,
        products: this.product,
        inCharge: this.inCharge,
        studentNameSearchField_contains: this.studentNameSearchField
          ? utils.removeUnicode(this.studentNameSearchField)
          : '',
        studentSchoolSearchField_contains: this.studentSchoolSearchField
          ? utils.removeUnicode(this.studentSchoolSearchField)
          : '',
        studentClassSearchField_contains: this.studentClassSearchField
          ? utils.removeUnicode(this.studentClassSearchField)
          : '',
        studentExpectSchoolSearchField_contains: this.expectSchoolSearchField
          ? utils.removeUnicode(this.expectSchoolSearchField)
          : '',
        importOrigin_contains: this.importOrigin,
        interest: this.interest,
        segment: this.segment,
        hasActiveCode: this.activeCodes
      }

      this.$emit('onFilterChanged', query)
    },
    formatExamOption(exam) {
      return `${exam.title} Khối ${exam.grade}`
    },
    formatExamSelection(exam) {
      return `${exam.title} Khối ${exam.grade}`
    }
  }
}
</script>
